import { ChangeDetectionStrategy, Component, OnInit, ViewChild, ViewEncapsulation, inject } from '@angular/core';
import { GtmGenericDialogsService, GtmImportPack, provideGtmGenericDialogsService } from '@partners/gtm';
import { DialogContainerComponent, DialogImportPack, FilledButtonComponent, IGuideConfig } from '@partners/ui';
import { InfoIconComponent } from '../../components';

/**
 * @description
 * a default guide dialog ui, contained within a dialog-container component. the container provides
 * a consistent dialog template structure with the following template slots: icon, title, body, footer
 * as well as close button, it also provides centralized access to basic common dialog behavior such
 * as dismiss function, dialog button behaviors, dialog animations etc'
 */

@Component({
  standalone: true,
  providers: [provideGtmGenericDialogsService()],
  imports: [FilledButtonComponent, DialogImportPack, InfoIconComponent, GtmImportPack],
  template: `

    <dialog-container #container gtmFunnelStepEvent="funnelStepEvent">
      <ng-template dialogIcon>
          <info-icon data-alt="אייקון אילוסטרציה שגיאה" />
      </ng-template>


      <ng-template dialogTitle let-context
        ><span>{{ context?.title }}</span></ng-template
      >

      <ng-template dialogBody let-context
        ><span>{{ context.message }}</span></ng-template
      >
      <ng-template dialogFooter let-context>
        <div class="dialog-action">
          <filled-button (click)="dismissGuide()" gtmClickEvent="okClickEvent"> {{ context.buttons.ok }} </filled-button>
        </div>
      </ng-template>
    </dialog-container>
  `,
  encapsulation: ViewEncapsulation.None,
  changeDetection: ChangeDetectionStrategy.OnPush,
  host: {
    class: 'guide-dialog'
  }
})
export class GuideComponent implements OnInit {
  private readonly _gtmService = inject(GtmGenericDialogsService);

  @ViewChild('container', { static: true, read: DialogContainerComponent })
  dialogContainer: DialogContainerComponent;

  ngOnInit() {
    this.setGtmDialogConfig();
  }

  setGtmDialogConfig() {
    const dialogConfig = this.dialogContainer.dialogConfig as IGuideConfig;

    const gtmDialogConfig = {
      message: dialogConfig.message || dialogConfig.title,
      buttons: {
        ok: dialogConfig.buttons?.ok
      }
    };

    this._gtmService.setDialogConfig(gtmDialogConfig);
  }

  dismissGuide() {
    this.dialogContainer.dismissDialog(undefined);
  }
}
